import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/apps/business/layouts/default.vue").then(m => m.default || m))
}